export const staticPages = {
  baseURL: "https://s3.amazonaws.com/static.dashboard.swiftmedical.io/",
  privacyPolicy: "PrivacyPolicy.html",
  eula: "TermsOfService.html"
};
